import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';

import { map } from 'rxjs';

import { JsonTransformService } from '@core/service/json-transform.service';

@Injectable()
export class JsonInterceptor implements HttpInterceptor {
  constructor(private readonly jsonTransform: JsonTransformService) {}

  intercept(httpRequest: HttpRequest<unknown>, next: HttpHandler) {
    const handledRequest: HttpRequest<unknown> = this.handleJsonRequest(httpRequest);

    if (httpRequest.responseType === 'json') {
      return this.handleJsonResponse(handledRequest, next);
    }
    return next.handle(handledRequest);
  }

  private handleJsonRequest(event: HttpRequest<unknown>) {
    if (typeof event.body === 'object' && !(event.body instanceof FormData)) {
      const cloneRequest = event.clone({
        body: this.jsonTransform.camelToSnakeCase(event.body),
      });
      return cloneRequest;
    }
    return event;
  }

  private handleJsonResponse(httpRequest: HttpRequest<unknown>, next: HttpHandler) {
    return next.handle(httpRequest).pipe(
      map(event => {
        if (event instanceof HttpResponse && typeof event.body === 'object') {
          return event.clone({
            body: this.jsonTransform.snakeToCamelCase(event.body),
          });
        }
        return event;
      })
    );
  }
}
